import React from "react";

//Dashboard
import Dashboard from "../Pages/Dashboard";

// Import Authentication pages
import Login from "../Pages/Authentication/Login";
import Logout from "../Pages/Authentication/Logout";

import User from "../Pages/User";

import Machine from "../Pages/Machine";


import Company from "../Pages/Company";


import MachineSelection from "../Pages/machineSelection/index.js";

import ChillerDetail from "../Pages/Chillers/index.js";

import Compressor from "../Pages/Compressor/index.js";
import Parameter from "../Pages/Parameter/index.js";
import CompressorParameter from "../Pages/Parameter/index.js";
import CompressorDetail from "../Pages/Chillers/index.js";
import CompressorData from "../Pages/CompressorData/index.js";

const userRoutes = [
  { path: "/", component: <MachineSelection /> },
  { path: "/dashboard", component: <Dashboard /> },

  
];
const batchControlManagerRoutes = [

];
const qualityManagerRoutes = [
 
];
const productionManagerRoutes = [
 
];
const adminRoutes = [
 
  { path: "/user", component: <User /> },
  { path: "/company", component: <Company /> },
  { path: "/machine", component: <Machine /> },
];

const authProtectedRoutes = [
  { path: "/dashboard", component: <Dashboard /> },
 
  { path: "/user", component: <User /> },
 
  { path: "/company", component: <Company /> },
  { path: "/machine", component: <Machine /> },

  { path: "/", component: <MachineSelection /> },

  {path: "/overview", component: <MachineSelection/> },
    
{path:"/chiller",component: <ChillerDetail/> },
{path:"/compressorData",component: <CompressorData/> },
{path:"/compressor",component: <Compressor/> },
{path:"/parameter",component: <CompressorParameter/> },


       
  // this route should be at the end of all other routes
  // eslint-disable-next-line react/display-name
  // {
  //   path: "/",
  //   exact: true,
  //   component: <Navigate to="/main" />,
  // },
];

const publicRoutes = [
  { path: "/logout", component: <Logout /> },
  { path: "/Signin", component: <Login /> },
  
];

export {
  userRoutes,
  batchControlManagerRoutes,
  productionManagerRoutes,
  qualityManagerRoutes,
  adminRoutes,
  authProtectedRoutes,
  publicRoutes,
};
